import { useState, useEffect, useCallback } from 'react';
import { useConnectionState, useDataChannel, useLocalParticipant } from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';
import Conference from '../conference';
import PracticeRoom from '../PracticeRoom';

export default function Playground({ component, disconnect }) {
    const [transcripts, setTranscripts] = useState([]);
    const [isConnected, setIsConnected] = useState(false);
    const { localParticipant } = useLocalParticipant();
    const roomState = useConnectionState();

    useEffect(() => {
        if (roomState === ConnectionState.Connected) {
            localParticipant.setCameraEnabled(true);
            localParticipant.setMicrophoneEnabled(true);
            setIsConnected(true);
        }
    }, [localParticipant, roomState]);

    const onDataReceived = useCallback(
        (msg) => {
            if (msg.topic === 'transcription') {
                const decoded = JSON.parse(new TextDecoder('utf-8').decode(msg.payload));
                let timestamp = new Date().getTime();
                if ('timestamp' in decoded && decoded.timestamp > 0) {
                    timestamp = decoded.timestamp;
                }
                setTranscripts([...transcripts, { name: 'You', message: decoded.text, timestamp, isSelf: true }]);
            }
        },
        [transcripts]
    );

    useDataChannel(onDataReceived);

    return component === 'PracticeRoom' ? (
        <PracticeRoom disconnect={disconnect} isConnected={isConnected} />
    ) : (
        <Conference disconnect={disconnect} isConnected={isConnected} />
    );
}
